import React, { useEffect, useRef } from "react";

const MFloatingComponent = ({
  targetElement,
  floatingElement,
  isFloatingDisplayed,
  setIsFloatingDisplayed,
  side = "left",
  isTopPositioned = false,
  wrapperClassNames = "",
  // Clicks inside any [role="dialog"] are ignored by default so a floating menu
  // survives interactions with a modal it opened. A menu that itself lives in a
  // modal must turn this off, or no click anywhere in that modal closes it.
  ignoreClicksInsideDialogs = true,
}) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    /**
     * Detect if clicked on outside of element
     */
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        // Ignore clicks on NextUI popovers/modals (rendered in portals)
        const isInsidePopover =
          event.target.closest('[data-slot="content"]') ||
          event.target.closest(".nextui-popover-content") ||
          (ignoreClicksInsideDialogs && event.target.closest('[role="dialog"]'));
        if (isInsidePopover) {
          return;
        }
        setIsFloatingDisplayed(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef, ignoreClicksInsideDialogs]);

  const isLeftPositionned = side === "left";
  const isRightPositionned = side === "right";

  return (
    <div className={`relative ${wrapperClassNames}`}>
      {targetElement}
      {isFloatingDisplayed && (
        <div
          ref={wrapperRef}
          className={`absolute z-50 ${isLeftPositionned ? "left-0" : ""}${
            isRightPositionned ? "right-0" : ""
          }${isTopPositioned ? " bottom-[100%] mb-[8px]" : ""}`}
        >
          {floatingElement}
        </div>
      )}
    </div>
  );
};

export default MFloatingComponent;
